export default __webpack_public_path__ + "static/media/report.da1260af.png";